class Controller {
  constructor(Bus, Events, $stateParams, Sections) {
    "ngInject";

    this.Bus = Bus;
    this.Events = Events;
    this.$stateParams = $stateParams;

    this.activeParams = this.$stateParams;
    this.sections = Sections.fleetSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;

    this.addItemEvent = this.Events.getAddEvent("buses");
    this.filterEvent = this.Events.getFilterEvent("buses");
    this.paginateEvent = this.Events.getPaginateEvent("buses");
    this.sortEvent = this.Events.getSortEvent("buses");
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/buses/buses.controller.js